<!-- 谈判人接单列表/谈判人去接单页面都用到这个组件 -->
<template>
  <div class="negotiation-item">
    <!-- 左侧图片 -->
    <van-image
      class="item-image"
      radius="8px"
      :src="item.goodsImage"
      fit="cover"
    />

    <!-- 右侧内容区 -->
    <div class="item-content">
      <!-- 顶部信息行 -->
      <div class="left">
        <div class="top-info">
          <!-- 标签 -->
          <!-- 合并 -->
          <img
            width="27px"
            height="24px"
            style="margin-right: 8px"
            v-if="isMergeTrade"
            :src="require('@/img/pc/follow/merge.png')"
            :alt="$t('pcOrder.merged')"
          />
          <!-- 快单 -->
          <img
            width="45px"
            height="25px"
            v-if="isFastTrade"
            :src="require('@/img/pc/follow/fastOrder.png')"
            :alt="$t('mobileOrder.fastOrder')"
          />
          <div v-else class="custom-tag-pc" :class="tagClass">
            {{ tagText }}
          </div>
          <!-- 产品名称 -->
          <div class="goods-name">{{ item.goodsName }}</div>
        </div>

        <!-- 中间信息列表 -->
        <div class="middle-info">
          <div
            class="info-row"
            v-for="(person, index) in item.peopleList"
            :key="index"
          >
            <template v-if="person.phone">
              <!-- ： -->
              <span class="label">{{ person.text }}{{ $t("pcOrder.personLabelSeparator") }}</span>
              <span class="value">{{ person.name }} | {{ person.phone }}</span>
            </template>
          </div>
        </div>
        <!-- 旧的联系人 -->
        <!-- <div class="middle-info">
          <div class="info-row">
            <template v-if="type === 'swGetFollow'">
              <span class="label">货主：</span>
            </template>
            <template v-else>
              <span class="label" v-if="item.type === 20 && item.model === 1"
                >货主：</span
              >
              <span class="label" v-if="item.type === 20 && item.model === 2"
                >买家：</span
              >
              <span class="label" v-if="item.type === 30 && item.model === 1"
                >买家：</span
              >
              <span class="label" v-if="item.type === 30 && item.model === 2"
                >货主：</span
              >
            </template>
            <div class="value">
              {{ item.ownerName }}
              <div class="c999">|</div>
              {{ item.ownerMobile }}
            </div>
          </div>
          <div class="info-row">
            <template v-if="type === 'swGetFollow'">
              <span class="label">联系人：</span>
            </template>
            <template v-else>
              <span class="label" v-if="item.type === 20">谈判人：</span>
              <span class="label" v-if="item.type === 30 && item.model === 1"
                >销售商务：</span
              >
              <span class="label" v-if="item.type === 30 && item.model === 2"
                >采购商务：</span
              >
            </template>
            <div class="value">
              {{ item.contactName }}
              <div class="c999">|</div>
              {{ item.contactMobile }}
            </div>
          </div>
        </div> -->
        <!-- 底部按钮区  -->
        <div class="bottom-buttons">
          <template v-if="type === 'swGetFollow'">
            <el-button @click="blockTprGetFollow(item)"> 屏蔽该信息 </el-button>
            <el-button type="primary" @click="handlerTprGetFollow(item)">
              抢单
            </el-button>
          </template>
          <template v-else>
            <el-button
              @click="viewFastTradeContract(item)"
              v-if="isFastTrade && item.status == 2"
            >
              查看合同
            </el-button>
            <!-- 查看详情 -->
            <el-button @click="viewDetail(item)" v-if="!isFastTrade">
              {{ $t("buyOrders.viewDetails") }}
            </el-button>

            <el-button
              v-if="
                item.type === 30 &&
                item.model === 1 &&
                item.identity === 20 &&
                item.status == 1 &&
                item.orderId > 0
              "
              type="primary"
              @click="confirmTradeContract(item)"
            >
              确认交易合同
            </el-button>
            <!-- 生成交易合同 -->
            <el-button
              v-if="
                item.type === 30 &&
                item.model === 2 &&
                item.identity === 20 &&
                item.status == 1
              "
              type="primary"
              @click="onImproveInfo(item)"
              ><span v-if="isFastTrade">快捷</span>{{ $t("devUpdates.generateTradeContract") }}
            </el-button>
            <el-button
              v-if="item.model === 1 && item.status == 1 && isFastTrade"
              type="primary"
              @click="onImproveInfo(item)"
              >快捷生成采购合同
            </el-button>
            <!-- 验货 -->
            <el-button
              @click="goToInspection(item)"
              v-if="
                Number(this.item.type) === 1 &&
                this.item.clueId == -1 &&
                this.item.clueType == 1 &&
                this.item.isInspection
              "
            >
              {{ $t("mobileOrder.inspectGoods") }}
            </el-button>
            <!-- 验货详情 -->
            <el-button
              @click="goToInspectionDetail(item)"
              v-if="
                Number(this.item.type) === 1 &&
                this.item.clueId == -1 &&
                this.item.clueType == 1 &&
                this.item.inspectorStatus == 1
              "
            >
              {{ $t("mobileOrder.inspectionDetails") }}
            </el-button>
            <el-button
              v-if="item.status == 5"
              type="primary"
              @click="onPay(item)"
            >
              去支付
            </el-button>
          </template>
        </div>
      </div>

      <div class="right">
        <!-- 价格区域 -->
        <div class="price-area">
          <div class="flex ju_end">
            <div class="price">{{ $formatPrice(item.goodsPrice) }}</div>
            <!-- priceUnit2 -->
            <!-- 元 -->
            <div class="currency">
              <span v-if="item.goodsPriceUnit == 10">美</span>{{ $t("pcPublish.yuan") }}
            </div>
          </div>

          <div class="quantity">
            <!-- 数量 -->
            <span class="count">{{ $t("pcBrand.quantity") }}</span> {{ item.goodsQuantity
            }}<span class="countUnit">{{ item.goodsUnit }}</span>
          </div>
        </div>
        <!-- 时间信息 -->
        <div class="create-time">
          {{
            type === "swGetFollow"
              ? $formatTime(item.createTime)
              : $formatTime(item.followTime)
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  computed: {
    // 标签样式类名
    tagClass() {
      const { type, model } = this.item;
      // 抢单页面标签逻辑
      if (this.type === "swGetFollow") {
        return model === 1 ? "tag_blue" : "tag_green";
      }
      // 跟单页面标签逻辑
      const classMap = {
        "20_1": "tag_blue", // type=20,model=1
        "20_2": "tag_green", // type=20,model=2
        "30_1": "tag_blue", // type=30,model=1
        "30_2": "tag_green", // type=30,model=2
      };
      return classMap[`${type}_${model}`] || "";
    },
    // 标签文本内容
    tagText() {
      const { type, model } = this.item;
      // 抢单页面标签文本
      if (this.type === "swGetFollow") {
        return model === 1 ? "货主" : "买家";
      }
      // 跟单页面标签文本
      const textMap = {
        "20_1": "货主货源商务",
        "20_2": "购买商品商务",
        "30_1": "货主交易商务跟单",
        "30_2": "买家交易商务跟单",
      };

      return textMap[`${type}_${model}`] || "";
    },
    isFastTrade() {
      return this.item.clueId == -1 && this.type !== "swGetFollow";
    },
    isMergeTrade() {
      return (
        this.item.multiOrder != null &&
        this.item.multiOrder &&
        this.type !== "swGetFollow"
      );
    },
  },
  methods: {
    // 查看谈判人跟单详情
    viewDetail(item) {
      this.$router.push("/follow/swFollowDetail/" + item.id);
    },
    // 查看谈判人跟单详情
    viewFastTradeContract(item) {
      // model 1 采购商务-采购订单 2 销售商务-销售订单
      var path = "";
      if (item.model === 1) {
        path = `/follow/fastPurchaseContractDetail`;
      } else {
        path = `/follow/fastTradeContractDetail`;
      }
      this.$router.push({
        path: path,
        query: {
          id: item.contractId || "",
          preOrderId: item.preOrderId,
        },
      });
    },
    // 抢单
    handlerTprGetFollow(item) {
      this.$emit("sw-get-follow", item);
    },
    // 屏蔽该信息
    blockTprGetFollow(item) {
      this.$emit("sw-block-follow", item);
    },
    // 完善合同
    onImproveInfo(item) {
      if (this.isFastTrade) {
        let path = "";
        // model 1 采购商务-采购订单 2 销售商务-销售订单
        if (item.model === 1) {
          path = `/follow/fastPurchaseContract?id=${item.ownerUserId}&goodsCode=${item.goodsCode}`;
        } else {
          path = `/follow/fastTradeContract?id=${item.ownerUserId}&orderId=${item.preOrderId}`;
        }
        this.$router.push(path);
      } else {
        this.$router.push("/follow/generateTradeContract?id=" + item.id);
      }
    },
    // 确认交易合同
    confirmTradeContract(item) {
      this.$router.push(
        "/follow/confirmTradeContract?orderId=" +
          item.orderId +
          "&followId=" +
          item.id,
      );
    },
    // 去支付
    onPay() {
      this.$router.push("/externalPay");
    },
    // 去验货页面
    goToInspection(item) {
      this.$router.push(
        "/myxg/myYanHuoDetail2?goodsCode=" + item.goodsCode + "&mode=edit",
      );
    },
    goToInspectionDetail(item) {
      this.$router.push(
        "/myxg/myYanHuoDetail2?goodsCode=" + item.goodsCode + "&mode=view",
      );
    },
  },
};
</script>

<style lang="less" scoped>
.negotiation-item {
  display: flex;
  gap: 28px;
  padding: 36px 0;
  border-bottom: 1px solid #eee;

  .item-image {
    width: 220px;
    height: 180px;
    flex-shrink: 0;
  }

  .item-content {
    display: flex;
    flex: 1;

    .left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;

      // 头部信息区域
      .top-info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .goods-name {
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 22px;
          font-weight: 700;
          margin-left: 8px;
        }
      }

      // 中间联系人区域
      .middle-info {
        display: flex;
        flex-direction: column;
        gap: 6px;

        .info-row {
          display: flex;
          align-items: center;

          .label {
            color: #999;
            min-width: 60px;
          }

          .value {
            flex: 1;
            display: flex;
            align-items: center;
            gap: 8px;
          }
        }
      }

      // 按钮区域
      .bottom-buttons {
        display: flex;
        gap: 10px;

        .el-button {
          border-radius: 8px !important;
          font-size: 18px !important;
          padding: 10px 52px !important;
        }
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      // 价格区域
      .price-area {
        text-align: right;

        .price {
          font-size: 36px;
          font-weight: bold;
          color: #1890ff;
        }

        .currency,
        .quantity {
          font-size: 14px;
          color: #1890ff;
        }

        .currency {
          margin-top: 20px;
          margin-left: 4px;
        }

        .quantity {
          margin-top: 8px;

          .count {
            color: #999;
          }

          .countUnit {
            color: #999;
            margin-left: 4px;
          }
        }
      }

      // 时间区域
      .create-time {
        font-size: 14px;
        color: #999;
        text-align: right;
      }
    }
  }
}
</style>
